/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useCallback, useEffect } from "react";
import "../css/integration.css";
import callApi from "../utils/apiCaller";
import Swal from "sweetalert2";
import uuid from "uuid-random";
import {
  DeleteMajor,
  DomainNewMajor,
  DuplicateMinor,
  ExchangeMajor,
  ExistingInventoryMajor,
} from "@shopify/polaris-icons";
import moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  Button,
  Card,
  Banner,
  Icon,
  Modal,
  Badge,
  Link,
  TextContainer,
  TextField,
  Checkbox,
  Heading,
  Toast,
  Frame,
  Select,
} from "@shopify/polaris";
import { Row, Table, Col } from "reactstrap";
import config from "../config/config";
import { actFetchDataSettings, actFetchListStore, actFetchShowLoadingPage } from "../actions/index";

import { useDispatch, useSelector } from "react-redux";
import Instructions from "./Instructions";
import Tabs from "./Settings/Tabs";
import PaypalSettings from "./Settings/PaypalSettings";
import Mollie from "./Settings/Mollie";
import Account from "./Account";
import Stripe from "./Settings/Stripe";
import { useHistory } from "react-router-dom";
import Key from "./Settings/Key";
import Integration from "./Integration";
import General from "./Settings/General";
import BannerWoo from "./Dashboard/BannerWoo";
import BannerDispute from "./dispute/BannerDispute";
import Analysis from "./dispute/Analysis";
import DisputeTable from "./dispute/DisputeTable";
import "../css/whatsapp.scss";

const WhatsappChat = () => {
  const dispatch = useDispatch();
  const dataSettings = useSelector((state) => state.dataSettings);
  const [timeSelected, setTimeSelected] = useState("30_days");
  const optionsTimeRange = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 7 days", value: "7_days" },
    { label: "Last 30 days", value: "30_days" },
    { label: "This month", value: "this_month" },
    { label: "Last month", value: "last_month" },
  ];
  return (
    <div id="wpp-fix" className="right shake">
      <button
        onClick={() =>
          window.open(
            "https://wa.me/+84359316798?text=Hi%2C%20I%27m%20from%20" +
              config.shop +
              "%20store.%20I%20need%20support%20for%20Synctrack.",
            "_blank"
          )
        }
        id="wpp-link"
        className="wpp-form wpp-link"
      >
        <svg height="682pt" viewBox="-23 -21 682 682.667" width="682pt" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M544.387 93.008C484.512 33.063 404.883.035 320.05 0 145.246 0 2.98 142.262 2.91 317.113c-.024 55.895 14.577 110.457 42.331 158.551L.25 640l168.121-44.102c46.324 25.27 98.477 38.586 151.55 38.602h.134c174.785 0 317.066-142.273 317.132-317.133.036-84.742-32.921-164.418-92.8-224.36zM320.05 580.94h-.11c-47.296-.02-93.683-12.73-134.16-36.742l-9.62-5.715-99.766 26.172 26.628-97.27-6.27-9.972c-26.386-41.969-40.32-90.476-40.296-140.281.055-145.332 118.305-263.57 263.7-263.57 70.406.023 136.59 27.476 186.355 77.3s77.156 116.051 77.133 186.485C583.582 462.69 465.34 580.94 320.05 580.94zm144.586-197.418c-7.922-3.968-46.883-23.132-54.149-25.78-7.258-2.645-12.547-3.962-17.824 3.968-5.285 7.93-20.469 25.781-25.094 31.066-4.625 5.29-9.242 5.953-17.168 1.985-7.925-3.965-33.457-12.336-63.726-39.332-23.555-21.012-39.457-46.961-44.082-54.89-4.617-7.938-.04-11.813 3.476-16.173 8.578-10.652 17.168-21.82 19.809-27.105 2.644-5.29 1.32-9.918-.664-13.883-1.977-3.965-17.824-42.969-24.426-58.84-6.437-15.445-12.965-13.36-17.832-13.601-4.617-.231-9.902-.278-15.187-.278-5.282 0-13.868 1.98-21.133 9.918-7.262 7.934-27.73 27.102-27.73 66.106s28.394 76.683 32.355 81.972c3.96 5.29 55.879 85.328 135.367 119.649 18.906 8.172 33.664 13.043 45.176 16.695 18.984 6.031 36.254 5.18 49.91 3.14 15.226-2.277 46.879-19.171 53.488-37.68 6.602-18.51 6.602-34.374 4.617-37.683-1.976-3.304-7.261-5.285-15.183-9.254zm0 0"
            fillRule="evenodd"
          />
        </svg>
      </button>
      <div className="form-wpp">
        <div className="head-wpp">
          <img
            src="https://www.davidsonsilva.com.br/wp-content/themes/davidson/assets/img/apple-touch-icon-152x152.png"
            loading="lazy"
            decoding="aync"
            width={50}
            height={50}
            className=" img-responsive wp-image-228"
            srcSet
            sizes="(max-width: 50px) 100vw, 50px"
            alt="Imagem perfil"
          />
          <h3>Chame no WhatsApp</h3>
          <i className="fas fa-times" id="close-bt" />
        </div>
      </div>
      <div className="mask" />
    </div>
  );
};

export default WhatsappChat;
